import { useState } from 'react';

interface ShareBarProps {
  title: string;
}

export default function ShareBar({ title }: ShareBarProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  const handleNativeShare = async () => {
    if (typeof navigator.share === 'function') {
      try {
        await navigator.share({ title, url: window.location.href });
      } catch {
        // 用户取消分享，无需处理
      }
    } else {
      handleCopy();
    }
  };

  return (
    <div className="mt-10 flex flex-wrap items-center gap-3 rounded-lg border border-background-200 bg-background-100 p-4">
      <span className="text-sm text-foreground-400">
        <i className="ri-share-forward-line mr-1.5 text-primary-400"></i>
        把这条转给还在等的人
      </span>
      <div className="flex flex-wrap items-center gap-2 sm:ml-auto">
        <button
          type="button"
          onClick={handleCopy}
          className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300/70 px-3.5 py-2 text-xs text-foreground-300 transition-colors hover:border-primary-500/60 hover:text-primary-300"
        >
          <i className={copied ? 'ri-check-line text-secondary-400' : 'ri-link'}></i>
          {copied ? '链接已复制' : '复制链接'}
        </button>
        <button
          type="button"
          onClick={handleNativeShare}
          className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-3.5 py-2 text-xs font-medium text-background-950 transition-colors hover:bg-primary-400"
        >
          <i className="ri-send-plane-line"></i>
          立即分享
        </button>
      </div>
    </div>
  );
}